<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';

export default Vue.extend({
    data() {
        return {
            toggled: true
        }
    },
    computed: {
        ...mapState({
            part: state => state.contract.contract.part,
            progress: state => state.contract.contract.progress.item,
            contract: state => state.contract.contract.item,
        }),
        ...mapGetters({
            calculateContractProgress: 'contract/calculateContractProgress',
            contractProgressObject: 'contract/contractProgressObject'
        })
    },
    methods: {
        ...mapActions({
            setContractFormPart: 'contract/setContractFormPart'
        })
    }
});
</script>
<template>
    <div class="contract-form-progress">
        <div class="contract-form-progress__header" @click="toggled = !toggled">
            <div :class="{'contract-form-progress__heading--toggled': toggled}" class="contract-form-progress__heading">
                <span>{{ $t('contract.form.progress.header.heading') }} </span>
                <span><i class="fa fa-angle-right"/> {{ calculateContractProgress }} %</span>
            </div>
        </div>
        <transition name="fade" type="in-out">
            <div v-if="toggled" class="contract-form-progress__content">
                <div class="contract-form-progress__items">
                    <div class="contract-form-progress__item">
                        <div class="contract-form-progress__item-label">
                            {{ $t('contract.form.progress.label') }}
                        </div>
                        <div class="contract-form-progress__item-elements">
                            <div v-for="(item, index) in progress"
                                 :key="index"
                                 class="contract-form-progress__item-element"
                                 @click="setContractFormPart({part: index})">
                                <div class="contract-form-progress__item-sub-header">
                                    {{ $t('contract.form.progress.part.' + index) }}
                                </div>
                                <div :class="[
                                         {'contract-form-progress__item-icon--done': item},
                                         {'contract-form-progress__item-icon--notification': item.note && !item.accepted},
                                         {'contract-form-progress__item-icon--active': part === index}]"
                                     class="contract-form-progress__item-icon">
                                    <span v-if="item"><i class="fa fa-check-square"/></span>
                                    <span v-if="!item"><i class="fa fa-minus-square"/></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormProgress/ContractFormProgress.vue